// extracted by mini-css-extract-plugin
export default {"noData":"SequenceSkillProgressChart_noData__TSKVV"};